import React from 'react';

import './styles.css';

const VideoInterferencia = () => {
    const iframeStyle = {
        width: '100%',
        height: '100vh', // Defina a altura como 100vh para ocupar a altura da tela
        border: 'none',
    };

    return (
        <>
            <iframe
                title="Gigabyte HD TV"
                src="https://www.youtube.com/embed/6qJzqDVLoEc?autoplay=1"
                frameBorder="0"
                allowFullScreen
                style={iframeStyle} // Aplicando o estilo aqui
            ></iframe>
            <span>Fonte: https://www.cpt.com.br/cursos-informatica-redesdecomputadores/artigos/redes-wireless-conheca-mais-sobre-as-redes-locais-de-acesso-sem-fio</span>
        </>
    );
};

export default VideoInterferencia;
